import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {
  preventLeavePage,
  resetLeavePageActionResult,
  setNextPageUrl
} from '@app/core/leave-page-handler/actions/leave-page-internal';
import { isConfirmAction } from '@app/core/leave-page-handler/reducers/leave-page';
import * as fromPcs from '@app/pcs/reducer';
import { select, Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class LeavePageGuard  {

  constructor(private store: Store<any>) {
  }

  canDeactivate(
    route,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) {
    // set next page URL
    this.store.dispatch(setNextPageUrl(nextState.url));
    // reset previous leave page action
    this.store.dispatch(resetLeavePageActionResult());

    return this.store.pipe(select(fromPcs.getLeavePageState)).pipe(
      tap(({formStatusInfo: {formDirty}, action}) => {
        if (formDirty && !action) {
          this.store.dispatch(preventLeavePage());
        }
      }),
      map(({formStatusInfo: {formDirty}, action}) => !!(!formDirty || isConfirmAction(action)))
    );
  }

}
